const overlay = document.querySelector('[data-argyre-transition]');
if (overlay && !window.Shopify?.designMode) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let navigating = false;
  let fallback;
  const hide = () => {
    clearTimeout(fallback);
    overlay.removeAttribute('data-active');
    navigating = false;
  };
  const show = () => {
    overlay.setAttribute('data-active', '');
    // Never leave a blocked screen after a failed or cancelled navigation.
    clearTimeout(fallback);
    fallback = setTimeout(hide, 4000);
  };
  window.addEventListener('pageshow', (event) => { if (event.persisted) hide(); });
  window.addEventListener('pagehide', hide);
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || reduceMotion.matches || navigating) return;
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('on:click')) return;
    // Drawer navigation should stay immediate and never sit behind the full-screen transition.
    if (link.closest('header-drawer')) return;
    // Product cards already use Shopify's native image-to-product transition.
    // Avoid stacking the full-screen logo transition on top of it.
    if (link.closest('product-card[data-product-transition], product-card-link[data-product-transition]')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return;
    if (/^\/(cart|checkout|checkouts|account|customer_authentication|admin|challenge)(\/|$)/.test(url.pathname)) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    if (link.closest('variant-picker,quick-add-component') || url.searchParams.has('variant')) return;
    event.preventDefault();
    navigating = true;
    show();
    setTimeout(() => location.assign(url.href), 360);
  });
}
